import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-green-50 to-white py-16 md:py-24 px-4" data-id="element-298">
      <div className="max-w-5xl mx-auto" data-id="element-299">
        <div className="text-center mb-12" data-id="element-300">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8 leading-tight" data-id="element-301">
            Por eso creamos Dominando Shopify.
          </h2>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-4 border-green-500" data-id="element-302">
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-6" data-id="element-303">
              <span className="font-bold text-green-700" data-id="element-304">
                Dominando Shopify
              </span>{' '}
              es un programa práctico, básico a intermedio, pensado para que
              puedas crear desde cero una estructura real para vender por
              internet.
            </p>

            <p className="text-lg md:text-xl text-gray-600 mb-4" data-id="element-305">
              No está armado para confundirte con teoría infinita.
            </p>

            <p className="text-lg md:text-xl font-bold text-gray-900" data-id="element-306">
              Está armado para que avances.
            </p>
          </div>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 mb-8" data-id="element-307">
          <p className="text-xl md:text-2xl mb-6 leading-relaxed" data-id="element-308">
            La idea es que puedas entender y montar, paso a paso:
          </p>

          <div className="grid md:grid-cols-2 gap-4 text-lg" data-id="element-309">
            {['tu producto', 'tu tienda', 'tu estructura de cobro', 'tu configuración básica', 'tus anuncios', 'y tu camino para empezar a vender'].map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-310">
                <span className="text-green-400 text-2xl" data-id="element-311">✓</span>
                <span data-id="element-312">{item}</span>
              </div>)}
          </div>

          <div className="mt-8 pt-8 border-t border-gray-700 space-y-3 text-lg" data-id="element-313">
            <p className="font-semibold" data-id="element-314">Todo con una lógica clara.</p>
            <p className="font-semibold" data-id="element-315">Todo explicado de forma simple.</p>
            <p className="font-semibold" data-id="element-316">Todo orientado a implementación.</p>
          </div>
        </div>

        <div className="text-center" data-id="element-317">
          <CTAButton text="QUIERO CREAR MI NEGOCIO ONLINE" onClick={scrollToCompra} size="large" data-id="element-318" />
        </div>
      </div>
    </section>;
}